export { default } from './TablePagination';


//////////////////
// WEBPACK FOOTER
// ./node_modules/@material-ui/core/esm/TablePagination/index.js
// module id = 365
// module chunks = 0